export default {
    fastappfeedbackList: {
		url: '/admin/fastappfeedback/list',		
	},
    fastappfeedbackUpdate: {
		url: '/admin/fastappfeedback/update',		
	},
    fastappfeedbackBlackBookList: {
		url: 'admin/fastappfeedback/blackBookList',		
	},
    fastappfeedbackSetBookBlack: {
		url: '/admin/fastappfeedback/setBookBlack',		
	},
	fastapptoolBaseAdvList: {
		url: '/admin/fastapptool/baseAdvList',		
	},
	fastapptoolAddBaseAdv: {
		url: '/admin/fastapptool/addBaseAdv',		
	},
	fastapptoolUpdateBaseAdvt: {
		url: '/admin/fastapptool/updateBaseAdv',		
	},
	fastapptoolDelBaseAdv: {
		url: '/admin/fastapptool/delBaseAdv',		
	},
	fastapptoolShelfBaseAdv: {
		url: '/admin/fastapptool/shelfBaseAdv',		
	},
	fastappconfInfo: {
		url: '/admin/fastappconf/info',		
	},
	
    
    
}